<template>
  <el-form :model="consumeForm" label-width="80px" :loading="loading">
    <el-form-item label="消费数量" required>
      <el-input placeholder="比如消耗课时1.5,或者是消费金额200" v-model="consumeForm.count"/>
    </el-form-item>
    <el-form-item label="备注">
      <el-input type="textarea" placeholder="备注" v-model="consumeForm.remark" multiline/>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="save">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {consume} from './skuApi'

export default {
  name: 'skuConsume',
  data () {
    return {
      loading: false,
      consumeForm: {
        count: '1',
        remark: ''
      }
    }
  },
  props: {
    customer () {
      return null
    },
    sku () {
      return null
    }
  },
  watch: {
    customer (v) {
      this.consumeForm = {
        count: '1',
        remark: ''
      }
    },
    sku (v) {
      this.consumeForm = {
        count: '1',
        remark: ''
      }
    }
  },
  methods: {
    save () {
      this.loading = true
      const endLoading = () => {
        this.loading = false
      }
      this.consumeForm.customerId = this.customer.customerId
      this.consumeForm.skuId = this.sku.skuId
      consume(this.consumeForm).catch(endLoading).then(rsp => {
        const { code } = rsp
        endLoading()
        if (code === 0) {
          this.$message.success('消费成功')
          this.$emit('close')
          this.$emit('success')
        } else {
          const { message } = rsp
          this.$message.error(message)
        }
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sku/skuConsume.vue